import "./Footer.scss";
import {FaTelegramPlane} from "react-icons/fa";
import {BsInstagram, BsWhatsapp} from "react-icons/bs";
import {IoIosArrowUp} from "react-icons/io";
import logo from "../../assets/images/ekia.png";
import enamad from "../../assets/images/enamad.svg";

export default function Footer() {
    return (
        <div
            className="footer-styles position-relative"
            style={{borderTop: "1px solid lightgray"}}
            id="footer-container"
        >
            <div className="container pb-4">
                <div
                    className="position-absolute"
                    style={{top: 20, left: 20, cursor: "pointer"}}>
                    <div
                        className="border border-secondary rounded p-1"
                        onClick={() => {
                            // document.getElementById("layout-container").scrollTop = 0;
                            document.getElementById("header-container").scrollIntoView({
                                behavior: "smooth",
                                block: "nearest"
                            });
                        }}
                    >
                        <span className="fs-12 mx-1">بازگشت به بالا</span>
                        <IoIosArrowUp/>
                    </div>
                </div>
                <div className="d-flex align-items-center social-section">
                    <div className="mt-3">
                        <img src={logo} className="logo"/>
                    </div>
                    <div className="d-flex align-items-center mr-r-24">
                        <h6 className="title fs-14" style={{whiteSpace: "nowrap"}}>
                            شبکه های اجتماعی
                        </h6>
                        <div className="d-flex">
                            <div
                                className="px-2 py-1 m-2 rounded social"
                                style={{
                                    background:
                                        "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
                                    cursor: "pointer"
                                }}
                            >
                                <BsInstagram className="text-white"/>
                            </div>
                            <div
                                className="px-2 py-1 m-2 rounded social"
                                style={{backgroundColor: "#0088cc", cursor: "pointer"}}
                            >
                                <FaTelegramPlane className="text-white"/>
                            </div>
                            <div
                                className="px-2 py-1 m-2 rounded social"
                                style={{backgroundColor: "#00E676", cursor: "pointer"}}
                            >
                                <BsWhatsapp className="text-white"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center phone-section mt-4">
                    <div className="d-flex align-items-center mx-3">
                        <div className="font-14-500 text-nowrap">شماره تماس :</div>
                        <div className="d-flex align-items-center mr-r-12 text-dark text-opacity-75">
                            <span className="fs-14 font-14-400">{"01732221906"}</span>
                            <span className="pd-x-4 font-18-400">|</span>
                            <span className="fs-14 font-14-400">{"09363213700"}</span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mx-3">
                        <div className="fs-14 text-nowrap"> آدرس ایمیل :</div>
                        <div className="fs-14 mr-r-12 text-dark text-opacity-75">ekiahome1@gmail.com</div>
                    </div>
                </div>
                <div className="mt-4">
                    <p className="fs-14 font-14-400-26">
                        ایکیاهوم فروشگاهی اینترنتی است با هدف عرضه‌ی بهترین محصولات خانه و آشپزخانه که در آن سعی داریم
                        تا با ارائه محصولاتی با کیفیت، کارا، شیک، زیبا و دارای مناسب‌ترین قیمت و خدمات پس از فروش، شما
                        بتوانید هر آن‌چه را می‌خواهید با خیالی آسوده از میان انواع کالاها انتخاب کرده و با چند کلیک در
                        نشانی اعلامی خود تحویل بگیرید.
                        شما عزیزان با خرید از سایت ekiahome می‌توانید لذت زندگی به سبک مدرن، متفاوت و هوشمندانه را تجربه
                        کنید و با اطمینان خاطر، از کیفیت و کارایی محصولاتی گردآوری شده از میان برترین برندهای جهانی
                        کالاهای خانه و آشپزخانه بهره‌مند شوید.
                    </p>
                </div>
                <div className="d-flex justify-content-between justify-content-xl-start mt-4">
                    <div>
                        <div className="fs-14">آدرس فروشگاه:</div>
                        <div className="fs-14">
                            خیابان ولیعصر،جنب پاساژ صدرا،فروشگاه خانه ما.
                        </div>
                    </div>
                    <div className="d-flex">
                        <img src={enamad} className="w-auto" style={{height: "80px"}}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
